var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHr = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 314,
  height: 21,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#FFB800",
  d: "m157.154 1 9.154 9.154-9.154 9.154L148 10.154z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  stroke: "#FFB800",
  d: "m157.154 4.846 5.309 5.309-5.31 5.309-5.308-5.31z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#FFB800",
  strokeOpacity: 0.5,
  d: "M177 9.5h137M0 9.5h137"
})));
export { SvgHr as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzE0IiBoZWlnaHQ9IjIxIiB2aWV3Qm94PSIwIDAgMzE0IDIxIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE1Ny4xNTQiIHk9IjEiIHdpZHRoPSIxMi45NDYyIiBoZWlnaHQ9IjEyLjk0NjIiIHRyYW5zZm9ybT0icm90YXRlKDQ1IDE1Ny4xNTQgMSkiIHN0cm9rZT0iI0ZGQjgwMCIvPgo8cmVjdCBvcGFjaXR5PSIwLjUiIHg9IjE1Ny4xNTQiIHk9IjQuODQ1NyIgd2lkdGg9IjcuNTA3NjYiIGhlaWdodD0iNy41MDc2NiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTU3LjE1NCA0Ljg0NTcpIiBzdHJva2U9IiNGRkI4MDAiLz4KPGxpbmUgeDE9IjE3NyIgeTE9IjkuNSIgeDI9IjMxNCIgeTI9IjkuNSIgc3Ryb2tlPSIjRkZCODAwIiBzdHJva2Utb3BhY2l0eT0iMC41Ii8+CjxsaW5lIHkxPSI5LjUiIHgyPSIxMzciIHkyPSI5LjUiIHN0cm9rZT0iI0ZGQjgwMCIgc3Ryb2tlLW9wYWNpdHk9IjAuNSIvPgo8L3N2Zz4=";